<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path
        fill="inherit"
        stroke="none"
        d="M15.73 5.37a1.26 1.26 0 0 1 1.79 0l1.11 1.11a1.26 1.26 0 0 1 0 1.79l-1.83 1.82-2.9-2.9zM13.2 7.9l2.9 2.9-6.66 6.64q-.31.32-.76.45l-3.57 1 .99-3.57q.12-.45.45-.77zM16.63 4c-.6 0-1.18.24-1.6.66l-9.19 9.19q-.5.51-.7 1.2l-1.11 4c-.07.26 0 .54.2.73.19.2.46.27.72.2l4-1.11q.69-.2 1.2-.71l9.2-9.19a2.27 2.27 0 0 0-.01-3.2l-1.12-1.1c-.42-.43-1-.67-1.6-.67"
      />
    </svg>
  </span>
</template>
